/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */

export class ApprovedEvolution {
  dossierCode?: string; // ecf001
  dossierId?: string; // ecf001
  itemType?: string; // ecf001
  evolutionDate?: string; // ecf001
  courtDate?: string; // ecf001
  courtOfJustice?: string; // ecf001
  descisionDescriptionCode?: string; // ecf001
  evolutionDescriptionCode?: string; // ecf001
  isDocumentRead: boolean; // ecf001
  nextCourtDate?: string; // ecf001
  nextCourtHours?: string; // ecf001
  nextCourtMinutes?: string; // ecf001
  documentName?: string; // ecf001
  documentUrl?: string; // ecf001
  documentType?: string; // ecf001
  refusalReason?: string; // ecf001
  divertedDossierCode?: string; // ecf001
  evolutionParentKey?: string; // ecf001
  evoluComment?: string;
  oldDecisionDescription?: string;
  approvedChildren?: ApprovedEvolution[];
  evolutionKey: string;
  evoluHasNotes: boolean;

  // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
  /**
   * DO NOT MODIFY, your changes will be lost on next generation!
   * Generated code from template &quot;model-json.velocity&quot;
   */

  /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

  public static mergeJSON(instance: any, data: any): ApprovedEvolution {
    if (!data) {
      return instance;
    }
    if (data.dossierCode != null) {
      instance.dossierCode = data.dossierCode;
    }
    if (data.dossierId != null) {
      instance.dossierId = data.dossierId;
    }
    if (data.itemType != null) {
      instance.itemType = data.itemType;
    }
    if (data.evolutionDate != null) {
      instance.evolutionDate = data.evolutionDate;
    }
    if (data.courtDate != null) {
      instance.courtDate = data.courtDate;
    }
    if (data.courtOfJustice != null) {
      instance.courtOfJustice = data.courtOfJustice;
    }
    if (data.descisionDescriptionCode != null) {
      instance.descisionDescriptionCode = data.descisionDescriptionCode;
    }
    if (data.evolutionDescriptionCode != null) {
      instance.evolutionDescriptionCode = data.evolutionDescriptionCode;
    }
    if (data.nextCourtDate != null) {
      instance.nextCourtDate = data.nextCourtDate;
    }
    if (data.isDocumentRead != null) {
      instance.isDocumentRead = data.isDocumentRead;
    }
    if (data.nextCourtHours != null) {
      instance.nextCourtHours = data.nextCourtHours;
    }
    if (data.nextCourtMinutes != null) {
      instance.nextCourtMinutes = data.nextCourtMinutes;
    }
    if (data.documentName != null) {
      instance.documentName = data.documentName;
    }
    if (data.documentUrl != null) {
      instance.documentUrl = data.documentUrl;
    }
    if (data.documentType != null) {
      instance.documentType = data.documentType;
    }
    if (data.refusalReason != null) {
      instance.refusalReason = data.refusalReason;
    }
    if (data.divertedDossierCode != null) {
      instance.divertedDossierCode = data.divertedDossierCode;
    }
    if (data.evolutionParentKey != null) {
      instance.evolutionParentKey = data.evolutionParentKey;
    }
    if (data.evoluComment != null) {
      instance.evoluComment = data.evoluComment;
    }
    if (data.oldDecisionDescription != null) {
      instance.oldDecisionDescription = data.oldDecisionDescription;
    }
    if (data.evolutionKey != null) {
      instance.evolutionKey = data.evolutionKey;
    }
    if (data.evoluHasNotes != null) {
      instance.evoluHasNotes = data.evoluHasNotes;
    }
    return instance; // ir
  }

  public fromJSON(data: any): this {
    // cbn001
    return ApprovedEvolution.mergeJSON(this, data) as any;
  }

  public static mergeJSONFromObject(target: any, object: ApprovedEvolution) {
    // TODO: mapping
    return object;
  }

  // toJSON ensures that only class-defined fields are exported.
  public toJSON() {
    return ApprovedEvolution.mergeJSONFromObject({}, this);
  }

  // Compares this AppInfo instance with another AppInfo instance, recursively.
  // Transient fields are not considered.
  public equals(other: ApprovedEvolution): boolean {
    return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
  }

  /** ---- */

  /** end of template &quot;model-json.velocity&quot; */

  // </editor-fold>
}

/** end of template "model.velocity" */
